import { BigFormRow } from 'framework/ui/layout';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import { TimelineNoteWysiwygInput } from 'domain/shared/core/input';

type ProjectNoteFormProps = {
  label?: string;
};

const ProjectNoteForm = ({ label = 'Text' }: ProjectNoteFormProps) => (
  <>
    <BigFormRow>
      <TimelineNoteWysiwygInput artifactsSource="attachmentPaths" source="text" label={label} />
    </BigFormRow>
    <BigFormRow>
      <NoteAttachmentUploaderInput label="Attachments" source="attachmentPaths" isProjectService={true} />
    </BigFormRow>
  </>
);

export default ProjectNoteForm;
